export const translation = {
  en: {
    PORTFOLIO_REVIEW: 'Portfolio Review',
    PORTFOLIO: 'Portfolio',
    DIVERSIFICATION: 'Diversification',
    LOW_FEES: 'Low Fees',
    INCOME: 'Income',
    PERFORMANCE: 'Performance',
    DOWNSIDE_PROTECTION: 'Downside Protection',
    PORTFOLIO_OVERVIEW: 'Portfolio Overview',
    OVERVIEW: 'Overview',
    PORTFOLIO_HISTORY: 'Historical Performance Graph',
    DOWNSIDE: 'Downside',
    FEES: 'Fees',
    ASSET_CLASS: 'Asset Class',
    INDIVIDUAL_ASSET: 'Individual',
    REGION: 'Region',
    GLOBAL_SECTOR: 'Global Stock Sector',
    MACRO_FACTOR: 'Macro Factor',
    EQUITY_STYLE: 'Equity Style',
    BENCHMARK: 'Benchmark',
    REBALANCING_FREQUENCY: 'Rebalancing Frequency',
    MONTHLY: 'Monthly',
    QUARTERLY: 'Quarterly',
    ANNUALLY: 'Annually',
    HYPOTHETICAL_PORTFOLIO_HISTORY: 'Hypothetical Portfolio History',
    BASE_CURRENT_PORTFOLIO:
      'Based on the current composition of your portfolio',
    COMPARE_TO: 'Compare to',
    RETURNS_INCLUDING_DISTRIBUTIONS: 'Total Returns including Distributions',
    CRISIS_PERIOD_RETURNS: 'Crisis-Period Returns',
    UKRAINE_WAR_ONSET: 'Onset of Ukraine War and Interest Rate Hikes',
    GLOBAL_TARIFF_UNCERTAINTY: 'Global Tariff Uncertainty',
    COVID_19_PANDEMIC: 'Covid-19 Pandemic',
    OIL_PRICE_SHOCK: 'Oil Price Shock',
    FINANCIAL_CRISIS: 'Financial Crisis',
    MY_PORTFOLIO: 'My Portfolio',
    PERFORMANCE_DESCRIPTION_1:
      "The information below provides a snapshot of how well your portfolio has been doing. You will find the traditional measures, such as annualized returns for different investment horizons. Most importantly, we show you your portfolio’s risk-adjusted ratios (Sharpe Ratio, Roy's Safety First Criterion, and Sortino Ratio), which tell you how much risk was taken to generate the returns.",
    KEY_STATISTICS: 'Key Statistics',
    INCLUSIVE: 'inclusive',
    ANNUALIZED_RETURN: 'Annualized Return',
    ANNUALIZED_RETURNS: 'Annualized Returns',
    TOTAL_PORTFOLIO: 'Total Portfolio',
    TOP_10_HOLDINGS: 'Top 10 Holdings',
    SHARPE_RATIO: 'Sharpe Ratio',
    ROY_SAFETY: "Roy's Safety First Criterion",
    SORTINO_RATIO: 'Sortino Ratio',
    ONE_YEAR: '1-year',
    THREE_YEAR: '3-year',
    FIVE_YEAR: '5-year',
    SEVEN_YEAR: '7-year',
    TEN_YEAR: '10-year',
    TOTAL_RISK: 'Total Risk',
    DOWNSIDE_RISK: 'Downside Risk',
    MAXIMUM_DRAWDOWN: 'Maximum Drawdown',
    DOWNSIDE_CAPTURE: 'Downside Capture',
    FEE_IN_PORTFOLIO: 'Fees In This Portfolio',
    ASSET: 'Asset',
    WEIGHT: 'Weight',
    MER: 'MER',
    WEIGHTED_AVERAGE_MER: 'Weighted Average MER',
    YIELD: 'Yield',
    WEIGHTED_AVERAGE_YIELD: 'Weighted Average Yield',
    RISK_EXPOSURE_ANALYSIS: 'Risk Exposure Analysis',
    BY_MACRO_FACTOR: 'By Macroeconomic Factor',
    MACRO_RISK_EXPOSURE: 'Macroeconomic Risk Exposure',
    MONTH: {
      '01': 'January',
      '02': 'February',
      '03': 'March',
      '04': 'April',
      '05': 'May',
      '06': 'June',
      '07': 'July',
      '08': 'August',
      '09': 'September',
      10: 'October',
      11: 'November',
      12: 'December',
    },
    STYLE_TAB: {
      header: 'Portfolio-Level Style Analysis',
      subheader: 'Equity Style',
    },
    EQUITYSTYLE: {
      title: 'Style Factors',
      description1:
        'This section shows your portfolio’s equity style tilts using the North American Fama-French-Cahart (FFC) equity style factors: market, size, value, and momentum. In the table, portfolio-level style tilts are assessed using the partial correlation between your equity portfolio returns and each factor. If it is positive (and statistically significant), then your equity portfolio has exposure to the market, small size, value, and momentum.',
      description2:
        'If it is negative, then your equity portfolio is hedged to the market, and has exposure to large size, growth, and reversal. Further, since the partial correlation lies between -1 and 1, its magnitude shows the strength of the correlation.',
    },
    EQUITYSTYLE_TABLE: {
      header1: 'Style Factor',
      header2: 'Partial Correlation between Portfolio and Factor',
      header3: 'Style Tilt',
    },
    EQUITYSTYLE_INTERPRETATION: {
      title: 'Interpretation Guide',
      bullet1:
        'Values close to 1 indicate strong positive correlation with the factor',
      bullet2:
        'Values close to -1 indicate strong negative correlation with the factor',
      bullet3:
        '“-” indicates there is no significant correlation with the factor',
    },
    PRICEMULTIPLES: {
      title: 'Price Multiples',
      description1:
        'Price multiples help assess how "expensive" or "cheap" your stock portfolio is by looking at stock prices per dollar of a key financial metric. We display below the average price (P) to earnings (E), cash flow (CF), book (B), and sales (S) ratios for your portfolio and for the benchmark.',
      popup: 'You can change your benchmark on the Overview page.',
      note: 'Note that the conclusion re: value vs. growth in this table may be different from the one above if the geography of the FFC factors and benchmark are different.',
    },
    PRICEMULTIPLES_TABLE: {
      header1: 'P/E Ratio',
      header2: 'P/CF Ratio',
      header3: 'P/B Ratio',
      header4: 'P/Sales',
      portfolio: 'My Portfolio',
      benchmark: 'Equity Benchmark',
    },
    ASSETCLASS_MISC:
      'Convertible assets (excluding bonds and preferred shares), derivative contracts, and others.',
    ASSETCLASS_DERIVATIVES:
      'Includes swaps, options, futures, income trusts, and other unclassified investments.',
    ASSETCLASS_Fixed_Income: 'Includes cash and cash equivalents in funds.',
    ASSETCLASS_CASH: 'Non-interest-bearing cash in your investment account.',
    ASSETCLASS_ASSET_ALLOCATION: 'Includes fund of funds and balanced funds.',
    SECTOR: 'Sector',
    HOLDINGS: 'Holdings',
    OVERWEIGHT_TOOLTIP: 'Overweighted sectors are highlighted in blue.',
    MENU: {
      OVERVIEW: 'Overview',
      PERFORMANCE: 'Performance',
      DOWNSIDE: 'Downside',
      FEES: 'Fees',
      INCOME: 'Income',
      DIVERSIFICATION: 'Diversification',
      ASSET: 'Asset Class',
      INDIVIDUAL: 'Individual',
      REGION: 'Region',
      GLOBAL: 'Global Stock Sector',
      MACRO: 'Macro Factor',
      EQUITY: 'Equity Style',
    },
    REPLACE_TITLE: 'Replace Holdings',
    REPLACE_DESCRIPTION: {
      P1: 'Replace a short-history holding(s) in your portfolio',
      P2: 'with a similar security or fund to obtain a more comprehensive analysis.',
      P3: 'If you do not want to replace the holding(s), you can go back and use the ‘Include short-history holdings’ toggle at the top left of the scorecard.',
    },
    REPLACE_SUB1: 'Choose replacement holding(s)',
    REPLACE_SUB2: 'Select holding(s) to be replaced',
    REPLACE_SUB2_DESC:
      'If you have multiple short-history holdings, you can select and replace them one at a time. If you select two or more holdings at once, the replacement holding will receive the aggregate weight.',
    REPLACE_SEARCH_TOOLTIP:
      'Select at least one holding to replace before searching.',
    REPLACE_TABLE_TOOLTIP:
      'Check to replace with a similar security that has a longer history (ideally 5 years) for a more comprehensive analysis.',
    REPLACE_EMPTY_MESSAGE:
      'You have no short history holdings to replace. If you would like to edit your replacements, please start over by analyzing this account on the Accounts page.',
    START_DATE_TOOLTIP:
      'The start date is the month after the inception/IPO date of your holding or April 2007, whichever comes later.',
    ANALYZE: 'Analyze',
    ZERO_PRICE:
      'Unfortunately, this security cannot be added as its price is $0.',
  },
  fr: {
    PORTFOLIO_REVIEW: 'Examen du portefeuille',
    PORTFOLIO: 'Portefeuille',
    DIVERSIFICATION: 'Diversification',
    LOW_FEES: 'Frais faibles',
    INCOME: 'Revenu',
    PERFORMANCE: 'Performance',
    DOWNSIDE_PROTECTION: 'Protection contre les baisses',
    PORTFOLIO_OVERVIEW: 'Aperçu du portefeuille',
    OVERVIEW: 'Aperçu',
    PORTFOLIO_HISTORY: 'Graphique de performance hypothétique',
    DOWNSIDE: 'Risque de pertes',
    FEES: 'Frais',
    ASSET_CLASS: "Analyse de la classe d'actifs",
    INDIVIDUAL_ASSET: 'Individuelle',
    REGION: 'Région',
    GLOBAL_SECTOR: 'Secteur Mondial',
    MACRO_FACTOR: 'Facteur macro',
    EQUITY_STYLE: "Style d'équité",
    BENCHMARK: 'Référence',
    REBALANCING_FREQUENCY: 'Fréquence de rééquilibrage',
    MONTHLY: 'Mensuel',
    QUARTERLY: 'Trimestriel',
    ANNUALLY: 'Annuel',
    HYPOTHETICAL_PORTFOLIO_HISTORY: 'Historique hypothetique du portefeuille',
    BASE_CURRENT_PORTFOLIO:
      'Selon la composition actuelle de votre portefeuille',
    COMPARE_TO: 'Comparer à',
    RETURNS_INCLUDING_DISTRIBUTIONS: 'Rendement total placements compris',
    CRISIS_PERIOD_RETURNS: 'Périodes de turbulences des marchés',
    UKRAINE_WAR_ONSET:
      'Début de la guerre en Ukraine et hausses des taux d’intérêt',
    GLOBAL_TARIFF_UNCERTAINTY:
      'Incertitude mondiale entourant les droits de douane',
    COVID_19_PANDEMIC: 'Pandémie de covid-19',
    OIL_PRICE_SHOCK: 'Choc des prix du pétrole',
    FINANCIAL_CRISIS: 'Crise financière',
    MY_PORTFOLIO: 'Mon portefeuille',
    PERFORMANCE_DESCRIPTION_1:
      'Les renseignements ci-dessous donnent un aperçu de la performance de votre portefeuille. Vous y trouverez les mesures traditionnelles, comme les rendements annualisés pour différentes périodes d’investissement. Mais surtout, nous vous présentons les ratios ajustés au risque de votre portefeuille (ratio de Sharpe, critère de sécurité de Roy et ratio de Sortino), qui indiquent combien de risque a été pris pour générer ces rendements.',
    KEY_STATISTICS: 'Statistiques clés',
    INCLUSIVE: 'inclusivement',
    ANNUALIZED_RETURN: 'Rendements annualisés',
    ANNUALIZED_RETURNS: 'Rendement annualisé',
    TOTAL_PORTFOLIO: 'Portefeuille total',
    TOP_10_HOLDINGS: '10 principaux titres',
    SHARPE_RATIO: 'Ratio de sharpe',
    ROY_SAFETY: 'Le Critère de sécurité de Roy',
    SORTINO_RATIO: 'Ratio de sortino',
    YTD: 'YTD',
    ONE_YEAR: '1 an',
    THREE_YEAR: '3 an',
    FIVE_YEAR: '5 an',
    SEVEN_YEAR: '7 an',
    TEN_YEAR: '10 an',
    TOTAL_RISK: 'Risque total',
    DOWNSIDE_RISK: 'Risque de perte',
    MAXIMUM_DRAWDOWN: 'Baisse maximale',
    DOWNSIDE_CAPTURE: 'Capture à la baisse',
    FEE_IN_PORTFOLIO: 'Frais dans ce portefeuille',
    ASSET: 'Actif',
    WEIGHT: 'Prépondérance',
    MER: 'RFG',
    WEIGHTED_AVERAGE_MER: 'RFG moyen pondéré',
    YIELD: 'Rendement',
    WEIGHTED_AVERAGE_YIELD: 'Rendement Moyen Pondéré',
    RISK_EXPOSURE_ANALYSIS: "Analyse de l'exposition au risque",
    BY_MACRO_FACTOR: 'Par facteur macroéconomique',
    MACRO_RISK_EXPOSURE: 'Exposition aux risques macroéconomiques',
    MONTH: {
      '01': 'Janvier',
      '02': 'Février',
      '03': 'Mars',
      '04': 'Avril',
      '05': 'Mai',
      '06': 'Juin',
      '07': 'Juillet',
      '08': 'Août',
      '09': 'Septembre',
      10: 'Octobre',
      11: 'Novembre',
      12: 'Décembre',
    },
    STYLE_TAB: {
      header: 'Analyse du style au niveau du portefeuille',
      subheader: "style de l'équité",
    },
    EQUITYSTYLE: {
      title: 'Facteurs de style',
      description1:
        'Cette section présente les inclinaisons de style d’actions de votre portefeuille, selon les facteurs Fama-French-Carhart (FFC) nord-américains : marché, taille, valeur et momentum. Dans le tableau, les inclinaisons de style au niveau du portefeuille sont évaluées à l’aide de la corrélation partielle entre les rendements de votre portefeuille d’actions et chaque facteur. Si elle est positive (et statistiquement significative), votre portefeuille d’actions présente une exposition au marché, aux titres de petite capitalisation, de valeur et à la dynamique (momentum).',
      description2:
        'Si elle est négative, votre portefeuille d’actions est couvert contre le marché et présente une exposition aux titres de grande capitalisation, de croissance et au renversement (reversal). De plus, comme la corrélation partielle se situe entre -1 et 1, son ampleur indique la force de la corrélation.',
    },
    EQUITYSTYLE_TABLE: {
      header1: 'Facteur de style',
      header2: 'Corrélation partielle entre le portefeuille et le facteur',
      header3: 'Inclinaison de style',
    },
    EQUITYSTYLE_INTERPRETATION: {
      title: 'Guide d’interprétation',
      bullet1:
        'Les valeurs proches de 1 indiquent une forte corrélation positive avec le facteur',
      bullet2:
        'Les valeurs proches de -1 indiquent une forte corrélation négative avec le facteur',
      bullet3:
        ' « - » indique qu’il n’y a pas de corrélation significative avec le facteur',
    },
    PRICEMULTIPLES: {
      title: 'Multiples de prix',
      description1:
        'Les multiples de prix permettent d’évaluer dans quelle mesure votre portefeuille d’actions est « cher » ou « bon marché » en examinant le prix des actions par dollar d’une mesure financière clé. Nous présentons ci-dessous les ratios moyens prix (P)/bénéfices (E), flux de trésorerie (CF), valeur comptable (B) et ventes (S) pour votre portefeuille et pour votre indice de référence.',
      popup:
        'Vous pouvez modifier votre indice de référence dans la page Aperçu.',
      note: 'Notez que la conclusion concernant valeur vs. croissance dans ce tableau peut différer de celle ci-dessus si la géographie des facteurs FFC et de l’indice de référence diffère.',
    },
    PRICEMULTIPLES_TABLE: {
      header1: 'Ratio P/E',
      header2: 'Ratio P/CF',
      header3: 'Ratio P/B ',
      header4: 'P/Ventes',
      portfolio: 'Mon portefeuille',
      benchmark: 'Référence',
    },
    ASSETCLASS_MISC:
      'Actifs convertibles (à l’exclusion des obligations et des actions privilégiées), contrats dérivés et autres.',
    ASSETCLASS_DERIVATIVES:
      "Comprend les swaps, les options, les contrats à terme, les fiducies de revenu et d'autres placements non classés.",
    ASSETCLASS_Fixed_Income:
      'Comprend l’encaisse et les quasi-espèces dans les fonds.',
    ASSETCLASS_CASH:
      'Encaisse non porteuse d’intérêts dans votre compte de placement.',
    ASSETCLASS_ASSET_ALLOCATION:
      'Comprend les fonds de fonds et les fonds équilibrés.',
    SECTOR: 'Secteur',
    HOLDINGS: 'Avoirs',
    OVERWEIGHT_TOOLTIP: 'Les secteurs surpondérés sont indiqués en bleu.',
    MENU: {
      OVERVIEW: 'Aperçu',
      PERFORMANCE: 'Performance',
      DOWNSIDE: 'Risque de pertes',
      FEES: 'Frais',
      INCOME: 'Revenu',
      DIVERSIFICATION: 'Diversification',
      ASSET: 'Classe d’actifs',
      INDIVIDUAL: 'Individuelle',
      REGION: 'Région',
      GLOBAL: 'Secteur mondial',
      MACRO: 'Facteur macro',
      EQUITY: 'Style de l’équité',
    },
    REPLACE_TITLE: 'Remplacer la ou les positions',
    REPLACE_DESCRIPTION: {
      P1: 'Remplacez une position avec un historique court dans votre portefeuille',
      P2: 'par une valeur mobilière ou un fonds similaire afin d’obtenir une analyse plus complète.',
      P3: 'Si vous ne souhaitez pas remplacer la ou les positions, vous pouvez revenir en arrière et utiliser l’option « Inclure les avoirs à court historique » en haut à gauche du tableau de bord.',
    },
    REPLACE_SUB1: 'Choisir la ou les positions de remplacement',
    REPLACE_SUB2: 'Sélectionner la ou les positions à remplacer',
    REPLACE_SUB2_DESC:
      'Si vous avez plusieurs positions avec un historique court, vous pouvez les sélectionner et les remplacer une à une. Si vous sélectionnez deux positions ou plus en même temps, la position de remplacement recevra le poids total combiné.',
    REPLACE_SEARCH_TOOLTIP:
      'Sélectionnez au moins une position à remplacer pour procéder à la recherche.',
    REPLACE_TABLE_TOOLTIP:
      'Vérifiez s’il est possible de remplacer par un titre similaire ayant un historique plus long (idéalement 5 ans) afin d’obtenir une analyse plus complète.',
    REPLACE_EMPTY_MESSAGE:
      'Vous n’avez aucun titre avec un historique limité à remplacer. Si vous souhaitez modifier vos remplacements, veuillez recommencer en analysant ce compte depuis la page Comptes.',
    START_DATE_TOOLTIP:
      'La première date est le mois suivant la date de création/IPO de votre avoir ou avril 2007, selon la date la plus récente.',
    ANALYZE: 'Analyser',
    ZERO_PRICE:
      'Malheureusement, cette valeur mobilière ne peut pas être ajoutée car son prix est de 0 $.',
  },
};
